import React, {useContext} from 'react';
import PropType from 'prop-types';
import './WelcomeTooltip.css';
import DragToRotateTooltip from './DragToRotateTooltip';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import { Button } from 'web-store-modules/packages/web-store-ui-library';
import { cdnUrl } from '../../../../../variables/Variables';
import { isIpadDevice, isIpadSafari } from '../../../utils/DeviceDetector';

const browseImg = `${cdnUrl}salesforce/Mousee.png`;
const productImg = `${cdnUrl}salesforce/PinTap.gif`;
const exploreImg = `${cdnUrl}salesforce/character-head.svg`;
const isMobile = isMobileDevice();
const isIpad = isIpadDevice();
const isIpadAndSafari = isIpadSafari();
const desktopTooltip = !isMobile ? {top:'0%'} : {};
const tooltipComponentContainer = isIpad || isIpadAndSafari ? { top: '40%' } : {};
const buttonWidth = isMobile ? '240px' : '210px';

const WelcomeTooltip = (props) => {
    const { welcomeMessageStyle, children, showBroseTooltip, showProductTooltip, showBeautyTooltip, isVisible,
        storeId, showMobileTooltip, isMobile, onWelcomeHide, t } = props;
    const tooltipClass = !isVisible ? 'tooltip-fadeout' : ''

    const onModalHidden = () => {
        onWelcomeHide();
    }

    return (
        <div id="tooltip-container" className={tooltipClass} style={desktopTooltip}>
            <div id="tooltip-component-container" className="flex-center" style={tooltipComponentContainer}>
                <div className="tooltip-row">
                    <div className="tooltip-col fadeInTooltip" style={{marginBottom: isMobile && '20px' }}>
                        <h3>BROWSE</h3>
                        <span className="tooltip-message">
                            Click and drag the screen or use the arrows on the floor to explore.
                        </span>
                        <DragToRotateTooltip imgStyle={{ width: '7em', height: '7em', marginBottom: isMobile && '20px'}} isTemplate image={browseImg} classes={'tooltip-first-img'} />
                    </div>
                    <div className={'tooltip-col ' + (showProductTooltip ? 'fadeInTooltip' : '')}>
                        {showProductTooltip && <><h3>PRODUCT</h3>
                            <span className="tooltip-message">
                                Click on the icon to see product details and shop online.
                            </span>
                            <DragToRotateTooltip imgStyle={{ width: '5em', height: '5em' }} isTemplate image={productImg} /> </>}
                    </div>
                    <div className={'tooltip-col ' + (showBeautyTooltip ? 'fadeInTooltip' : '')}>
                        {showBeautyTooltip && <><h3>DISCOVER</h3>
                            <span className="tooltip-message">
                                Click to explore additional product content, style guides, inspiration and more.
                            </span>
                            <DragToRotateTooltip  isTemplate image={exploreImg} classes={'star exploreIcon'} /></>}
                    </div>
                </div>
                <Button
                    hoverStyleChange={false}
                    onClick={onModalHidden}
                    primaryColor='white'
                    secondaryColor='white'
                    className="product-button flex-center obsessvr-regularFont full-width pointer exploreNowBtn"
                    style={{ padding: '0', borderRadius: '4px', width: buttonWidth,pointerEvents: 'all' }}
                    primaryBorderColor={"white"}
                    secondaryBorderColor={"white"}
                    insetBorder={true}
                    padded={false}
                >
                    <span className='obsessvr-regularFont ' style={{color:'black', fontSize: '11px', fontFamily: 'SourceSansPro-Bold'}}>
                        EXPLORE NOW
                    </span>
                </Button>
                {children}
            </div>
        </div>
    );
};

WelcomeTooltip.propTypes = {
    welcomeMessageStyle: PropType.object,
    showBroseTooltip: PropType.bool,
    showBeautyTooltip: PropType.bool,
    showProductTooltip: PropType.bool,
};

export default WelcomeTooltip;
